import { Box } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ApplicationStatus,
  applyEvent,
  CommonOrCommonRetirementFlug,
  FormClassApply,
  Prefectures,
  SexFlug,
  Status,
} from "../../assets/data/Constants";
import TkButton from "../../components/atoms/TkButton";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkTable from "../../components/atoms/TkTable";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkMemo from "../../components/molecules/TkMemo";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import {
  IAPI_APP016_Request,
  IAPI_INQ012_Request,
  IAPI_INQ013_Response,
} from "../../type/apiType";
import { TkGetCode } from "../../utils/TkGetCode";
import {
  changeAmountFormat,
  isStatusAfterApproval,
} from "../../utils/useTools";
import { funTransferHistoryList } from "../SCRW110007/hooks/useHooks";
import "./_style.scss";
import { httpAPI_APP016, httpAPI_INQ012, httpAPI_INQ013 } from "./api/request";
import { funInfoBodyList } from "./hooks/useHooks";
import {
  demanderSchema,
  fakeTableList,
  infoHeadTitleList,
  monthMapping,
  schema,
  SubmitTableList,
  symbolHeadList,
} from "./parts";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import _ from "lodash";
import TkSelectForm from "../../components/atoms/TkSelectForm";
import TkCheckbox from "../../components/atoms/TkCheckbox";

/**
 * SCRW110007コンポーネント。
 * このコンポーネントは、TkInfoManualとTkFakeTableをレンダリングします。
 * @returns JSX.Element
 */
const SCRW110007 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const [status, setStatus] = useState<string>(); // ステータス
  const [showButton, setShowButton] = useState<boolean>(false); // ステータス
  const [resData, setResData] = useState<any>();
  const [memoData, setMemoData] = useState(""); // メモデータ
  const [memoCheck, setMemoCheck] = useState(false); // メモチェック
  const [bodyList, setBodyList] = useState<any>(); // bodyList
  const [corpApplyKbn, setCorpApplyKbn] = useState<any>(); // corpApplyKbn
  const [stateTableList, setStateTableList] = useState<any>([]); // stateTableList
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [stateSubmitTableList, setStateSubmitTableList] = useState<any>([]); // stateTableList
  const stateSubmitTableListRef = useRef(_.cloneDeep(SubmitTableList));
  const [symbolBodyList, setSymbolBodyList] = useState<any[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [approvalDate, setApprovalDate] = useState<string>();
  const [symbolNo, setSymbolNo] = useState<string>();
  const [selectedYear, setSelectedYear] = useState<string>("");
  const [monthArr, setMonthArr] = useState<any>({});
  const applyId = location.state?.applyId;

  const handleInit = async () => {
    try {
      // 職員照会各種請求参照APIを呼び出す。
      const res = await httpAPI_INQ013({
        applyId,
      });

      if (res.resultCd === "I0000") {
        // 処理履歴
        const bodyListData: any = [];
        res.statusList?.forEach((item, index: number) => {
          const data = [
            { children: item.managerName },
            { children: item.process },
            { children: item.createDate },
            { children: item.processComment },
          ];
          bodyListData.push(data);
        });
        setBodyList(bodyListData);

        // ArrにfakeTablelistを格納
        let resArr = stateFakeTableList.current;
        // 職員名
        resArr.find((item) => item.keyword === "staffNameKanji")!.text =
          (res.staffNo ?? "") + ":" + (res.staffNameKanji ?? "");
        // 性別
        resArr.find((item) => item.keyword === "sex")!.text = TkGetCode(
          SexFlug,
          res.sex
        );
        //職種
        resArr.find((item) => item.keyword === "jobName")!.text = res.jobName;
        // 生年月日
        resArr.find((item) => item.keyword === "birthday")!.text = res.birthday;
        //加入日
        resArr.find((item) => item.keyword === "firstJoinDate")!.text =
          res.firstJoinDate;
        //在籍期間
        resArr.find((item) => item.keyword === "periodOfEnrollment")!.text = `${
          res.premiumEnrollYear?.toString() ?? 0
        }年${res.premiumEnrollMonth?.toString() ?? 0}ヶ月`;
        //退職日
        resArr.find((item) => item.keyword === "retireDate")!.text =
          res.retireDate;
        //俸給表の額
        resArr.find((item) => item.keyword === "salaryTableAmt")!.text =
          res.salaryTableAmt
            ? `${changeAmountFormat(res.salaryTableAmt!)}円`
            : "";
        // 俸給の調整額
        resArr.find((item) => item.keyword === "salaryAdjustmentAmt")!.text =
          res.salaryAdjustmentAmt
            ? `${changeAmountFormat(res.salaryAdjustmentAmt!)}円`
            : "";
        //合計
        resArr.find((item) => item.keyword === "sum")!.text = res.sum
          ? `${changeAmountFormat(res.sum!)}円`
          : "";
        //退職届提出日
        resArr.find((item) => item.keyword === "applyDate")!.text =
          res.applyDate;
        //支給額
        resArr.find((item) => item.keyword === "paymentAmt")!.text =
          res.paymentAmt ? `${changeAmountFormat(res.paymentAmt)} 円` : "";
        //送金予定日
        resArr.find((item) => item.keyword === "remitDueDate")!.text =
          res.remitDueDate;

        // 育休テーブル
        const infoBodyList = funInfoBodyList(res.childcareLeaveList);
        resArr.find((item) => item.keyword === "childcareLeaveList")!.node = (
          <Box className="SCRW110007childcareLeaveList">
            <TkTable bodyList={infoBodyList} headList={infoHeadTitleList} />
          </Box>
        );

        // 異動履歴の作成
        const transferHistoryList = funTransferHistoryList(
          res.transferHistoryList
        );

        resArr.find(
          (item) => item.keyword === "transferHistoryList"
        )!.dataList = transferHistoryList;

        setStateTableList([...resArr]);
        const disabled =
          res.latestApplyStatus === Status["届出待ち"] ||
          res.latestApplyStatus === Status["差戻し一時保存"];
        let resArrForm = stateSubmitTableListRef.current;
        //請求者の氏名
        let businessOwnerClass = resArrForm.find(
          (item) => item.keyword === "businessOwnerClass"
        )!;
        businessOwnerClass.setDefaultValue = res.demanderNameKanji;
        businessOwnerClass.disabled = !disabled;
        //請求者のメールアドレス
        let email = resArrForm.find((item) => item.keyword === "email")!;
        email.setDefaultValue = res.demanderEmail;
        email.disabled = !disabled;
        //請求者のメールアドレス（確認用）
        let emailConfirm = resArrForm.find(
          (item) => item.keyword === "emailConfirm"
        )!;
        emailConfirm.setDefaultValue = res.demanderEmail;
        emailConfirm.disabled = !disabled;

        //通知書送付先住所（郵便番号）
        let deliveryZipcode = resArrForm.find(
          (item) => item.keyword === "deliveryZipcode"
        )!;
        deliveryZipcode.setDefaultValue = res.deliveryZipcode;
        deliveryZipcode.disabled = !disabled;
        // 住所検索
        deliveryZipcode.getPostalCodeValue = getPostalCodeValue;
        deliveryZipcode.getPostalCodeError = (value: any) => {
          setState({
            ...state,
            errorMsgId: value,
          });
        };
        //通知書送付先住所
        let deliveryAddress = resArrForm.find(
          (item) => item.keyword === "deliveryAddress"
        )!;
        deliveryAddress.valueObject = {
          prefectures: TkGetCode(Prefectures, res.deliveryPrefectureCd),
          city: res.deliveryAddressCity!,
          address: res.deliveryAddressOthers!,
        };
        deliveryAddress.disabled = !disabled;
        setSelectedYear(
          res?.unrecognizedMonthList
            ? String(res?.unrecognizedMonthList[0]?.year)
            : ""
        );
        setStateSubmitTableList([...resArrForm]);
        setStatus(res.latestApplyStatus!);
        setShowButton(disabled);
        setCorpApplyKbn(res.corpApplyKbn);
        setSymbolBodyList(formatLedgerData(res));
        setResData(res);
        setApprovalDate(res.decisionDate);
        setSymbolNo(res.symbolNo?.toString());
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const selectedMonthList = resData?.unrecognizedMonthList?.find(
      (unrecognizedMonth: any) =>
        Number(unrecognizedMonth?.year) === Number(selectedYear)
    );
    setMonthArr(selectedMonthList);
  }, [resData?.unrecognizedMonthList, selectedYear]);

  useEffect(() => {
    // ならない月
    if (!!monthArr && Object.keys(monthArr).length !== 0) {
      let resArr = stateFakeTableList.current;
      const unrecognizedMonthList = renderUnrecognizedMonthList(resData);
      resArr.find((item) => item.keyword === "unrecognizedMonthList")!.node =
        unrecognizedMonthList;
      setStateTableList([...resArr]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [monthArr]);

  /**
   * ならない月を作成する
   * @param res
   * @returns renderUnrecognizedMonthList
   */
  // 配列をループして各要素に対してUI要素を生成する関数
  const renderUnrecognizedMonthList = (res: IAPI_INQ013_Response) => {
    let selectYears =
      res?.unrecognizedMonthList?.map((item: any) => ({
        value: item.year?.toString(),
        label: item.year?.toString() + "年",
      })) ?? [];

    const monthNode = (
      <Box>
        <Box className="part">
          <TkSelectForm
            selectPropsList={selectYears}
            wantToSetValue={res?.unrecognizedMonthList?.[0]?.year}
            onChange={(e: any) => {
              setSelectedYear(e.target.value);
            }}
          />
        </Box>
        <Box>
          <TkCheckbox
            label="無"
            disabled={true}
            checked={
              !Object.values(monthArr!).some(
                (value) => value === "1" || value === "3"
              )
            }
          />
          {Object.keys(monthMapping).map((month: any, index: number) => {
            return (
              <TkCheckbox
                label={`${monthMapping[month]} 月`}
                disabled={true}
                checked={monthArr[month] === "1" || monthArr[month] === "3"}
                key={index}
                value={month}
              />
            );
          })}
        </Box>
      </Box>
    );

    return monthNode;
  };

  const formatLedgerData = (data: any) => {
    const file = data.formList?.find(
      (item: any) => item.formClass === "EXP0702036"
    );

    const shown = isStatusAfterApproval(data.latestApplyStatus);
    return [
      [
        {
          children: file ? (
            <TkDownloadLink
              base64filedata={file.fileBase64}
              dataname={TkGetCode(FormClassApply, file?.formClass)}
              downloadBase64={true}
            />
          ) : null,
        },
        {
          children: shown ? data.symbolNo : "",
        },
        {
          children: shown ? data.decisionDate : "",
        },
      ],
    ];
  };

  //住所検索
  const getPostalCodeValue = (target: any) => {
    if (!target.value) return;
    const value = target.value;
    let resArr = stateSubmitTableListRef.current;
    const data = value;
    let resObj = {
      prefectures: data.address1,
      city: `${data.address2}${data.address3}`,
      address: "",
    };
    resArr.find((item) => item.keyword === "deliveryAddress")!.valueObject =
      resObj;
    setState({
      ...state,
      errorMsgId: "",
    });
    // 修正: 住所検索後に表示がおかしくなるため削除(なくても正常に動く)
    // setStateTableList([...resArr]);
  };

  // 修正: メモ入力の変更イベントハンドラー
  const onChange = (event: any) => {
    if (event.target.type === "input") {
      // インプット要素の場合はメモデータを更新
      setMemoData(event.target.value);
    } else {
      // チェックボックスの場合はメモチェックを更新
      setMemoCheck(event.target.value);
    }
  };

  const ref = useRef<any>(null);

  // 登録ボタン　押下
  const handleResister = () => {
    ref.current.submit();
  };

  const makeHttpObjForUpdate = (obj: any): IAPI_INQ012_Request => {
    const reqObj: IAPI_INQ012_Request = {
      applyId,
      businessType: businessState.common?.businessType, // 		業務タイプ
      demanderNameKanji: obj.businessOwnerClass,
      demanderEmail: obj.email,
      contractorNo: businessState.common?.contractorNo,
      staffNo: resData.staffNo,
      demanderBirthday: resData.demanderBirthday, // 		職員照会問い合わせ.請求者生年月日
      demanderTel: resData.demanderTel, // 	職員照会問い合わせ.請求者電話番号
      demanderUserType: resData.demanderUserType, // 		請求者ユーザ.ユーザタイプ（9000:ユーザタイプ）
      deliveryZipcode: obj.deliveryZipcode, // 	申請等管理.通知書送付先住所（郵便番号）
      deliveryPrefectureCd:
        Prefectures[
          obj.deliveryAddress?.prefectures as keyof typeof Prefectures
        ], // 	申請等管理.通知書送付先住所（都道府県コード）
      deliveryAddressCity: obj.deliveryAddress?.city, // 	申請等管理.通知書送付先住所（市区町村）
      deliveryAddressOthers: obj.deliveryAddress?.address, // 	申請等管理.通知書送付先住所（その他）
      screenId: "SCRW110007",
    };
    return reqObj;
  };

  const onCheckAndSubmit = async (data: any) => {
    //職員照会問い合わせ更新
    try {
      const res = await httpAPI_INQ012({
        ...makeHttpObjForUpdate(data),
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC070008");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const btnEvent = async (btnName: keyof typeof applyEvent) => {
    let applyEventNo = applyEvent[btnName];
    if (
      ![
        applyEvent["通知"],
        applyEvent["受理"],
        applyEvent["承認"],
        applyEvent["契約者に差戻し"],
        applyEvent["上長承認"],
        applyEvent["担当者に差戻し"],
        applyEvent["課長代理確認"],
        applyEvent["郵送"],
      ].includes(applyEventNo)
    )
      return;

    if (applyEventNo === applyEvent["承認"]) {
      setIsOpen(true);
      return;
    }
    if (applyEventNo === applyEvent["担当者に差戻し"]) {
      if (status === "01" || status === "02") {
        applyEventNo = applyEvent["契約者に差戻し"];
      }
    }
    handleCallApi(applyEventNo);
  };

  const makeHttpObj = (applyEventNo: string, formData?: any) => {
    const data: IAPI_APP016_Request = {
      applyId: applyId, //申請ID
      contractorNo: resData.contractorNo, //共済契約者番号
      applyEvent: applyEventNo, //申請イベント
      reason: memoData, //メモ
      screenId: "SCRW110007", //画面ID
    };
    if (memoCheck) {
      data.inquiryCode = "3"; //照会画面への反映コード
    }
    if (formData) {
      data.symbolNo =
        TkGetCode(CommonOrCommonRetirementFlug, formData?.symbolNumberType) +
        "第" +
        formData?.symbolNumber +
        "号";
      data.decisionDate = formData?.settlementDate;
    }
    return data;
  };

  const handleCallApi = async (applyEventNo: any, formData?: any) => {
    let reqData: IAPI_APP016_Request = makeHttpObj(applyEventNo, formData);
    // 申請状況更新API呼び出し
    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box className={"SCRW110007"} data-testid="SCRW110007PageForTest">
      {!showButton && (
        <Box>
          <TkKikoStepper
            applicationFlowType="TYPE2"
            businessType="JOB-48"
            corporateApplicationClassification={corpApplyKbn}
            applicationStatus={status as keyof typeof ApplicationStatus}
          ></TkKikoStepper>
        </Box>
      )}

      <Box className="body">
        <TkFakeTable
          list={stateTableList}
          ruleSchema={schema}
          showButton={false}
        />

        <TkFakeTable
          ref={ref}
          list={stateSubmitTableList}
          ruleSchema={demanderSchema}
          onCheckAndSubmit={(data) => {
            onCheckAndSubmit(data);
          }}
          showButton={false}
        />
        {!showButton && (
          <TkMemo
            showTable={true}
            bodyList={bodyList}
            onChange={onChange}
          ></TkMemo>
        )}
        {symbolBodyList.length > 0 && (
          <TkTableWithNoLine
            headList={symbolHeadList}
            bodyList={symbolBodyList}
          />
        )}
      </Box>

      <Box className="btn">
        <TkBackButton mr={true}></TkBackButton>
        {showButton ? (
          <TkButton
            data-testid="SCRW110007ResisterButton"
            onClick={() => handleResister()}
          >
            登録
          </TkButton>
        ) : (
          <TkViewButtonJudgement
            flowType="TYPE2"
            businessType="JOB-48"
            Status={status as keyof typeof ApplicationStatus}
            onClick={btnEvent}
          />
        )}
      </Box>
      <TkApprovalDateSymbolNumberRegistrationDialog
        data-testid="SCRW110007PageForDialog"
        open={isOpen}
        onSuccess={(e: any) => handleCallApi(applyEvent["承認"], e)}
        onClose={() => setIsOpen(false)}
        wantToSetValue={{
          symbolNumber: symbolNo,
          settlementDate: approvalDate,
        }}
      />
    </Box>
  );
};
export default SCRW110007;
